import React, { useState, useEffect } from 'react';
import { OptionalState } from '../../utils/ReactHelper';
import Logger from '../../../common/utils/Logger';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import { ButtonVariant } from '../../utils/BootstrapHelper';
import { LoginRequest, LoginResponse, LoginValidation } from '../../../common/Login';
import * as yup from 'yup';
import * as formik from 'formik';
import Linker from '../../library/Linker';
import { PagePath } from '../PagePath';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

type Props = {
    linker: Linker;
};

type State = {
    show: boolean;
};

const StateDefault: State = {
    show: false
};

const AuthLogin = (props: Props) => {

    const [state, setState] = useState(StateDefault);

    const updateState = (updates: Partial<State>) => {
        setState(OptionalState(state, updates));
    };

    useEffect(() => {
        new Promise(async (resolve, reject) => {
            return Promise.resolve();
        });
    }, []);

    const variant: ButtonVariant = ButtonVariant.PrimaryOutline;

    const schema:yup.ObjectSchema<LoginRequest> = yup.object().shape({
        email: yup.string().email().required(),
        password: yup.string().required(),
    });

    const { Formik } = formik;

    const doToggleShow = (): void => {
        let newShow: boolean = !state.show;
        updateState({
            show: newShow
        });
    };

    const doSubmit = async (values: LoginRequest, actions: formik.FormikHelpers<LoginRequest>): Promise<void> => {
        Logger.Log(values, `values`, `doSubmit`);
        let response = await props.linker.Login(values);
        actions.setSubmitting(false);
        if (response.success) {
            location.href = `${location.origin}${PagePath.Home}`;
        } else {
            Logger.Log(response.message, `response.message`, `doSubmit`);
        }
        return Promise.resolve();
    };

    const doValidate = (values: LoginRequest) => {
        const errors: LoginValidation = {};

        if (!values.email) {
            errors.email = 'Required';
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
            errors.email = 'Invalid email address';
        }
        
        Logger.Log(errors, `errors`, `doValidate`);

        return errors;
    };

    return (
        <>
            <Formik
                validationSchema={schema}
                onSubmit={doSubmit}
                initialValues={{
                    email: '',
                    password: '',
                }}
                validate={doValidate}
                validateOnChange={false}
            >
                {({ values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="formLogin.email">
                            <Form.Control className="rounded-start-5 rounded-end-5" required type="email" placeholder="Email Address" value={values.email} onChange={handleChange} name='email'/>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formLogin.password">
                            <InputGroup> 
                                <Form.Control className="rounded-start-5" required type={state.show && 'text' || 'password'} placeholder="Password" value={values.password} onChange={handleChange} name='password' />
                                <Button variant={variant} onClick={doToggleShow} className="rounded-end-5" >
                                    {state.show && <FaEye></FaEye> || <FaEyeSlash></FaEyeSlash>}
                                </Button>
                            </InputGroup>
                        </Form.Group>
                        <Button type="submit" className="rounded-start-5 rounded-end-5">Submit</Button>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default AuthLogin;